import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import classnames from 'classnames';
import { useModal } from '@/providers/modal';
import { MODAL_IDS } from '@/kit/Modal/keys';
import { ModalCenterLayout } from '@/kit/Modal/layouts/center';
import { UploadField } from '@/kit/UploadField';
import { uploadFile } from '@/store/services/commonServices';
import Notify from '@/components/Notification';
import r from '@/kit/RoundButton/button.module.scss';
import s from './index.module.scss';

const id = MODAL_IDS.fpg_assets_modal;

export const FpgAssetsModal = props => {
  const { modalIds } = useModal();
  return modalIds[id] && <Modal {...props} />;
};

const Modal = ({ value, onUpload }) => {
  const [fpgAssets, setFpgAssets] = useState(value || []);
  const { closeModal } = useModal();
  const { t } = useTranslation('modal');
  const [loading, setLoading] = useState(false);

  const onConfirm = async () => {
    if (!fpgAssets.length) {
      onUpload([]);
      closeModal(id);
      return;
    }
    setLoading(true);
    const res = await Promise.all(
      fpgAssets.filter(file => !file.id).map(file => uploadFile(file, { protected: true })),
    )
      .catch(() => Notify.error('Upload failed'))
      .finally(() => {
        setLoading(false);
        closeModal(id);
      });

    if (res?.length) onUpload([...fpgAssets.filter(file => !!file.id), ...res.map(r => r.data)]);
  };

  const content = (
    <div className={classnames(s.modal, 'scr_modal_grid')}>
      <div className={classnames(s.title, 'f-h2 f-500')}>{t('fpg_assets_modal.title')}</div>
      <div className={s.content}>
        <div className="f-body-regular">{t('fpg_assets_modal.upload_instruction')}</div>
        <UploadField
          name="fpg_assets"
          value={fpgAssets}
          onChange={files => setFpgAssets(files)}
          uploading={loading}
        />
      </div>
      <div className={s.footer}>
        <button
          type="button"
          className={classnames(r.grey_large, s.btn_cancel)}
          onClick={() => closeModal(id)}
        >
          {t('fpg_assets_modal.cancel')}
        </button>
        <button type="button" className={classnames(r.black_large, s.btn_done)} onClick={onConfirm}>
          {t('fpg_assets_modal.confirm')}
        </button>
      </div>
    </div>
  );

  return (
    <ModalCenterLayout id={id} onClose={() => closeModal(id)} showClose>
      {content}
    </ModalCenterLayout>
  );
};
